import React, { Component } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import { JsonLd } from 'react-schemaorg';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import { daysDifAndTime, difDays } from 'helpers/formatDate';
import sensor from 'components/sensor';
import Link from 'components/link';
import { Thumb } from 'components/image';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';
import InteractiveComponent from 'components/interactive-fly-component';
import { FavoritesButton } from 'subsys/favorites';

import { renderCurrentRubrics, renderDevelopers, renderLC, renderOpinion } from './render-common';

import linksDomik from 'src-sites/domik/links';

import translates from './articles-i18n';

import 'styles/domik/mixins/_views-article.scss';

const bemClasses = new Bem('viewArticle');

@sensor
@I18nHoc(translates())
export default class ListArticle extends Component {
  static propTypes = {
    className: PropTypes.string,
    seoData: PropTypes.shape({}),
    dataMods: PropTypes.string,
    device: PropTypes.string,
    data: PropTypes.shape({}),
    favData: PropTypes.arrayOf(PropTypes.shape({}))
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.onHandleResize = this.onHandleResize.bind(this);
    this.onResize = this.onHandleResize;

    this.state = {
      device: 'phone'
    };
  }

  componentDidMount() {
    this.onHandleResize(this.sensor.getRuntime());
  }

  onHandleResize({ media: { desktop, tablet, phone } = {} }) {
    const { device } = this.state;
    if (desktop && device !== 'desktop') return this.setState({ device: 'desktop' });
    if (tablet && device !== 'tablet') return this.setState({ device: 'tablet' });
    if (phone && device !== 'phone') return this.setState({ device: 'phone' });
  }

  renderFavouriteButton() {
    const { favData } = this.props;
    const publication_id = get(this, 'props.publication.data[0].id') ||
      get(this, 'props.data.id') ||
      get(this, 'props.object.id') ;

    if (!publication_id) return null;

    const index = findIndex(favData, { entity_id: publication_id });

    return (
      <InteractiveComponent
        iconType={iconTypes.favoritesBorder}
        newIconType={iconTypes.favorites}
        destinationPoint="favoritesIcon"
      >
        <FavoritesButton
          {...bemClasses('favorite')}
          project="domik"
          entity="publication"
          entityId={publication_id}
          subgroup="article"
          inFavorites={index > -1}
          counterProps={{
            action: "favoritesArticleClick",
            entity: { publication_id }
          }}
          hideLabel
        />
      </InteractiveComponent>
    );
  }

  render() {
    // const { i18n } = this;
    // const { device } = this.state;
    const { className, dataMods = {}, seoData, number } = this.props;
    const data = get(this, 'props.data') || get(this, 'props.object') || {};
    const {
      image: img_main, name, short_text: annotation, comments, properties = {},
      users_data: developersList, time_to_publish, date_ed, landing_url, // img_in_list
    } = data;
    const header = get(seoData, 'header') ? seoData.header : name;
    const image = typeof img_main === 'string' ? { id: img_main } : img_main;
    const imageArticle = { ...image, alt: header, title: header };
    const currentRubrics = get(data, 'rubrics');
    const dataLC = get(data, 'lc_data');
    const isDeveloper = developersList && developersList.length;
    const isLC = dataLC && dataLC.length;
    const isExpertOpinion = get(properties, 'expertOpinion');
    // const isPhone = device === 'phone';
    const builderProps = {
      title: header,
      url: landing_url
    };
    const commentsCount = get(comments, 'count');
    const renderAnnotation = !isDeveloper && !isLC && !isExpertOpinion;

    return (
      <LazyHydrate
        whenVisible
        style={{}}
        {...bemClasses(null, dataMods, className)}
      >
        <article {...bemClasses('content')}>
          <div {...bemClasses('col', 'main')}>
            <Row {...bemClasses('row', 'articleInfo')}>
              <Col {...bemClasses('col', 'rubric')} allAuto allFlex allColumn allPr={0}>
                {renderCurrentRubrics.call(this, bemClasses, currentRubrics)}
              </Col>
              <Col {...bemClasses('col', 'time')} allAuto allFlex allColumn allPr={0}>
                <time
                  {...bemClasses('time')}
                  dateTime={time_to_publish}
                  children={daysDifAndTime.call(this, time_to_publish)}
                />
              </Col>
              {!!commentsCount &&
                <Col {...bemClasses('col', 'commentCount')} allAuto allFlex allColumn allPr={0}>
                  <div {...bemClasses('commentCount')}>
                    <div {...bemClasses('btn', 'toComment')}>
                      <span {...bemClasses('btnContent')}>
                        <Icon {...bemClasses('icon')} type={iconTypes.commentRound} />
                        <span {...bemClasses('text')} children={commentsCount} />
                      </span>
                    </div>
                  </div>
                </Col>
              }
            </Row>
            <header {...bemClasses('title')}>
              <h2>
                <Link
                  {...bemClasses('link', 'toArticle')}
                  builder={linksDomik.sectionLanding}
                  builderProps={builderProps}
                >
                  <span {...bemClasses('linkContent')}>
                    <span {...bemClasses('text')} children={header} />
                  </span>
                </Link>
              </h2>
            </header>
            {(isDeveloper || isLC || isExpertOpinion) &&
              <Row {...bemClasses('row', 'top')}>
                <Col {...bemClasses('col', 'developers')} allFlex allPr={0}>
                  {renderDevelopers.call(this, bemClasses, developersList)}
                  {renderLC.call(this, bemClasses, dataLC)}
                  {renderOpinion.call(this, bemClasses, data)}
                </Col>
              </Row>
            }
            {renderAnnotation &&
              <div {...bemClasses('main')}>
                <span {...bemClasses('text', 'main annotation')} children={annotation} />
              </div>
            }
          </div>
          <Row {...bemClasses('row', { img: true, imgBig: Math.round(number/3) * 3 === number })}>
            <Col {...bemClasses('col', 'img')} allPr={0}>
              <div {...bemClasses('imgContainer')}>
                <div {...bemClasses('img')}>
                  <Link
                    {...bemClasses('link', 'fill')}
                    builder={linksDomik.sectionLanding}
                    builderProps={builderProps}
                    children={<span />}
                  />
                  <Thumb
                    {...bemClasses('imgPic')}
                    image={imageArticle}
                  />
                  <JsonLd
                    item={{
                      '@context': 'https://schema.org',
                      '@type': 'ImageObject',
                      name: header || null,
                      description: header || null,
                      contentUrl: image ? absoluteUrl(`/images/thumb/full/${image.id}`) : null
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
          {this.renderFavouriteButton()}
          <footer />
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'Article',
              mainEntityOfPage: absoluteUrl(landing_url),
              image: get(image, 'id') ? absoluteUrl(`/images/thumb/full/${image.id}`) : null,
              headline: header || null,
              name: header || null,
              description: renderAnnotation && annotation || null,
              datePublished: time_to_publish || null,
              dateModified: date_ed || null
            }}
          />
        </article>
      </LazyHydrate>
    );
  }
}
